import React from "react";
import DatesRange from "./DatesRange";
import SimpleDatesRange from "./SimpleDatesRange";

const DatesRangeFactory = ({ datesRangeType = 'STANDARD', startDate, endDate, className = null, ...params }) => {

    switch (datesRangeType) {
        case 'STANDARD':
            return (
                <DatesRange startDate={startDate} endDate={endDate}
                    // showIcon={true} showLabel={false} showSeparator={true}
                    className={className} {...params}
                />
            );
        case 'SHORT':
            return (
                <SimpleDatesRange startDate={startDate} endDate={endDate} className={className} />
            );
        default:
            return (
                null
            );
    }

}

export default DatesRangeFactory;